export const VALIDITY_OPTIONS = [
  "Day",
  "Week",
  "One Month",
  "3 Months",
  "6 Months",
  "One Year",
  "Lifetime",
];

export const PLAN_TYPE_OPTIONS = ["Subscription", "One Time"];

// Plan Access options come from public.pro_plan_types via /pro-plan-types.
// Intentionally empty: hardcoding ids/labels here would mask a failed request
// and let the form write access ids that do not exist in the table.
export const PLAN_ACCESS_OPTIONS = [];

export const EMPTY_FORM = {
  id: null,
  name: "",
  description_text: "",
  validity: "Week",
  price_full: "",
  price_discounted: "",
  tip_message: "",
  plan_type: "One Time",
  active_status: "Yes",
  display: "Yes",
  plan_access_id: [],
  tnc: "",
  razorpay_plan: "",
  button_code: "",
};

export const ACCESS_LABEL_MAP = PLAN_ACCESS_OPTIONS.reduce((acc, item) => {
  acc[item.id] = item.label;
  return acc;
}, {});

// Maps pro_plan_types rows ({ id, types }) into the { id, label } shape the
// Plan Access tags render.
export const mapPlanTypesToAccessOptions = (planTypes = []) =>
  planTypes
    .map((item) => {
      const id = String(item?.id ?? "").trim();
      const label = String(item?.types ?? "").trim();
      if (!id || !label) return null;
      return { id, label };
    })
    .filter(Boolean);

export const normalizePlanAccess = (value) => {
  if (value == null || value === "") return [];

  if (Array.isArray(value)) {
    return value
      .map(String)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (typeof value === "object") {
    return Object.values(value)
      .map(String)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];

    try {
      return normalizePlanAccess(JSON.parse(trimmed));
    } catch {
      return trimmed
        .replace(/^\[|\]$/g, "")
        .split(",")
        .map((item) => item.replace(/^"|"$/g, "").trim())
        .filter(Boolean);
    }
  }

  return [String(value).trim()].filter(Boolean);
};

export const normalizePlan = (plan) => ({
  id: plan.id,
  name: plan.name ?? "",
  description_text: plan.description_text ?? "",
  validity: plan.validity ?? "Week",
  price_full: plan.price_full ?? "",
  price_discounted: plan.price_discounted ?? "",
  tip_message: plan.tip_message ?? "",
  plan_type: plan.plan_type ?? "One Time",
  active_status: plan.active_status ?? "Yes",
  display: plan.display ?? "Yes",
  plan_access_id: normalizePlanAccess(plan.plan_access_id),
  tnc: plan.tnc ?? "",
  razorpay_plan: plan.razorpay_plan ?? "",
  button_code: plan.button_code ?? "",
  created: plan.created ?? "",
  updated: plan.updated ?? "",
});

export const accessText = (ids, options = PLAN_ACCESS_OPTIONS) => {
  const labelMap = options.reduce((acc, item) => {
    acc[item.id] = item.label;
    return acc;
  }, {});
  const list = normalizePlanAccess(ids);
  return list.length
    ? list.map((id) => labelMap[id] || ACCESS_LABEL_MAP[id] || `Access ${id}`).join(", ")
    : "None";
};
